import React, { Component, useEffect } from 'react';
import { Tag, Modal, Form, Input, Button } from 'antd';
import InputList from '../../commonComponents/InputList';
import InputShootList from '../../commonComponents/InputShootList';
import { useState } from 'react';
export default function CreateShootMergeGuideline({
    HandleOnOK,
    onCancel,
    showCreate,
    loading,
    name = '',
    description = '',
    links = null,
    excludedLinks = null,
    validatedLinks = [],
}) {
    const [form] = Form.useForm();

    const [linksValidation, setLinksValidation] = useState(false);
    useEffect(() => {
        form.setFieldValue('name', name);
        form.setFieldValue('links', links);
        form.setFieldValue('validatedLinks', validatedLinks);
    }, [name]);

    return (
        <>
            <Modal
                open={showCreate}
                onCancel={onCancel}
                width="80%"
                title="Create Session"
                style={{ top: '20px' }}
                footer={[
                    <Button key="cancel" onClick={onCancel}>
                        Cancel
                    </Button>,
                    <Button
                        key="create"
                        type="primary"
                        onClick={() => form.submit()}
                        disabled={loading || linksValidation}
                        loading={loading}
                    >
                        Create
                    </Button>
                ]}
            >
                <div style={{ minHeight: '80dvh', maxHeight: '80dvh', overflow: 'auto' }}>
                    <Form form={form} onFinish={HandleOnOK} {...{ labelCol: { span: 24 }, wrapperCol: { span: 24 } }}>
                        <Form.Item
                            label="Name"
                            name="name"
                            colon={true}
                            rules={[
                                {
                                    required: true,
                                    message: 'Please Specify a name for the new session',
                                },
                            ]}
                        >
                            <Input />
                        </Form.Item>
                        <Form.Item
                            label="Team lead"
                            name="teamLead"
                            rules={[{ required: true, message: 'Please enter the team lead' }]}
                        >
                            <Input placeholder="Team lead name" />
                        </Form.Item>
                        <Form.Item
                            label="Add Merged Guidelines Link"
                            name="links"
                            colon={true}
                            rules={[
                                {
                                    type: 'array',
                                    required: true,
                                    message: 'Please Specify a List of Merge guideline Links. Atlease 1 link is required to merge',
                                },
                            ]}
                            style={{ minHeight: '60dvh', maxHeight: '80dvh' }}
                        >
                            <InputShootList
                                UpdateItems={links => {
                                    form.setFieldValue(
                                        'links',
                                        links.filter(d => d != '')
                                    );
                                }}
                                maxHeight="60dvh"
                                links={links}
                                setLinksValidation={setLinksValidation}
                                linksValidation={linksValidation}
                            />
                        </Form.Item>
                    </Form>
                </div>
            </Modal>
        </>
    );
}
